import { jsx } from "react/jsx-runtime";
import Editor$1 from "../Lookup/Editor.js";
import "@flatfile/design-system";
import "react";
import "../Lookup/Styles.js";
import "lodash.isequal";
import "../CellContainer.js";
import "../Styles.js";
import "match-sorter";
const Editor = (props) => {
  return /* @__PURE__ */ jsx(Editor$1, { ...props, isNewRowCell: props.isNewRowCell });
};
export {
  Editor as default
};
